import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { useTranslation } from 'react-i18next';

import React from 'react';
import {
  CompanyDetails,
  Container,
  DecoratedHeader,
  ProgressIndicator,
} from '../../../components';
import { useCompany } from '../../../hooks';
import {
  CompanyType,
  CorporateCompanyPageView,
  UserPermission,
} from '../../../enums';
import { Tab } from '../../../navigation';
import { NeedsPermission } from '../../../security';

interface Props {
  children: React.ReactNode;
  corporateCompanyId?: string;
  view: CorporateCompanyPageView;
  setView: React.Dispatch<React.SetStateAction<CorporateCompanyPageView>>;
}

const CorporateCompanyPartial = ({
  children,
  corporateCompanyId,
  view,
  setView,
}: Props) => {
  const { t } = useTranslation();
  const company = useCompany(corporateCompanyId || '');

  return (
    <>
      <Container>
        <DecoratedHeader
          icon={<BusinessCenterIcon />}
          title={t('navigation.companies')}
          to="/admin/corporate-companies"
          variant="colored"
        ></DecoratedHeader>
      </Container>
      <React.Fragment>
        {company.loading ? (
          <ProgressIndicator />
        ) : (
          <>
            <CompanyDetails
              company={company}
              companyType={CompanyType.CorporateCompany}
            />
            <Container sx={{ mt: 5 }}>
              <Tab
                title={t('navigation.associatedCompanies')}
                onClick={() =>
                  setView(CorporateCompanyPageView.CorporateCompanies)
                }
                active={view === CorporateCompanyPageView.CorporateCompanies}
              />
              <NeedsPermission oneOf={[UserPermission.ManageAgencyUsers]}>
                <Tab
                  title={t('navigation.assignedUsers')}
                  onClick={() =>
                    setView(CorporateCompanyPageView.AssignedUsers)
                  }
                  active={view === CorporateCompanyPageView.AssignedUsers}
                />
              </NeedsPermission>
            </Container>
          </>
        )}
      </React.Fragment>
      {children}
    </>
  );
};

export default CorporateCompanyPartial;
